export default async function GetLandNumber() {
    let url = window.RealestateService+  `/api/Land/GetLandNumber`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}